export default "/_next/static/images/680c02e3cbdcf0367c00cef96e3ea77d.png";